import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";

function PaidRewardlist() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const [TotalAmount, setTotalAmount] = useState(0);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/GetIncomeReportsAdmin",
        {
          loginid: userId,
          uid: search,
          fdate: formdate,
          tdate: todate,
          type: "myReward",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("My_Team", responceRight);
       //setTotalAmount(responceRight?.data?.TotalAmount);
   
      responceRight = responceRight?.data?.data[0];
      const TOTALAMOUNT = responceRight.reduce((sum, { reward }) => sum + reward, 0);
      setTotalAmount(TOTALAMOUNT);
      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item.RANK,
          rankname: item.rankname,
          LeftReq: item.LeftReq,
          LeftBus: item.LeftBus,
          RightReq: item.RightReq,
          RightBus: item.RightBus,
          reward: item.reward,
          remark: item.remark,
          achieveddate: item.achieveddate
          // sr: item.row,
          // uid: item.uid,
          // rank: item?.rank,
          // reqleg1: item?.reqleg1,
          // leg1: `  ${item.leg1} `,
          // reqleg2: item?.reqleg2,
          // leg2: `  ${item.leg2} `,
          // reward: item.reward,
          // achieved: item?.achstatus=="achieved"?(
          //   <span className="text-success"> A chieved</span>
          // ):(
          //   <span ></span>
          // ),
          // achieved_date: item.ad,
          // paid: item.paidstatus,
          // paid_date: item.pd,

        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Reward Name", accessor: "rankname" },
      { Header: "Left(Required)", accessor: "LeftReq" },
      { Header: "Left(Business)", accessor: "LeftBus" },
      { Header: "Right(Required)", accessor: "RightReq" },
      { Header: "Right(Business)", accessor: "RightBus" },
      { Header: "Reward", accessor: "reward" },
      { Header: "Remark", accessor: "remark" },
      { Header: "Ach.Date", accessor: "achieveddate" }
      // { Header: "S.No.", accessor: "sr" },
      // { Header: "User Id", accessor: "uid" },
      // { Header: "Reward", accessor: "reward" },
      // { Header: "Required Leg1", accessor: "reqleg1" },
      // { Header: "Leg1 Business", accessor: "leg1" },
      // { Header: "Required Leg2", accessor: "reqleg2" },
      // { Header: "Leg2 Business", accessor: "leg2" },
      // { Header: "Achieved status", accessor: "achieved" },
      // { Header: "Achieved Date", accessor: "achieved_date" },
      // // { Header: "Paid Status", accessor: "paid" },
      // // { Header: "Paid Date", accessor: "paid_date" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Reward Income</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-3">
                      <input
                        type="text"
                        id="txtuid"
                        ng-model="p.uid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(new Date(e.target.value))}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-3">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaidRewardlist;
